<template>
  <div id="rechargeCoupon">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>优惠券</el-breadcrumb-item>
          <el-breadcrumb-item>优惠券设置</el-breadcrumb-item>
          <el-breadcrumb-item>充值优惠券管理</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>

    <el-form :inline="true"
             label-width="100px"
             class="pageSearch">
      <el-row>
        <el-form-item label="客户名称::">
          <el-select v-model="selCustID"
                     filterable
                     clearable
                     @change="setQuerySeller($event)"
                     placeholder="请选择客户">
            <el-option v-for="item in choiceCusts"
                       :key="item.fCustID"
                       :label="item.unionName"
                       :value="item.fCustID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="优惠券分类::">
          <el-select v-model="fGroupID"
                     filterable
                     placeholder="请选择优惠券分类"
                     clearable>
            <el-option v-for="item in selCouponGroupList"
                       :key="item.fGroupID"
                       :label="item.fGroupName"
                       :value="item.fGroupID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商户分组::">
          <el-select v-model="selGroupID"
                     filterable
                     clearable
                     @change="changeGroup"
                     placeholder="请选择商户分组">
            <el-option v-for="item in choiceGroups"
                       :key="item.fSelGrpID"
                       :label="item.fSelGrpName"
                       :value="item.fSelGrpID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商户名称::">
          <el-select v-model="selSellID"
                     filterable
                     clearable
                     placeholder="请选择商户">
            <el-option v-for="item in choiceSellers"
                       :key="item.fSelID"
                       :label="'【' + item.fSelName + '】' + item.fMerName"
                       :value="item.fSelID">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item style="float:right;margin-right:0px;">
          <el-button type="primary"
                     size="small"
                     v-if="is_edit"
                     @click="addCouponBatch">新增优惠券</el-button>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="优惠券名称::">
          <el-input placeholder="请输入优惠券名称"
                    v-model="selBatTtl"
                    style="width:200px;"
                    class="input-with-select">
          </el-input>
        </el-form-item>
        <el-form-item label="优惠券状态::">
          <el-select v-model="fStatus"
                     filterable
                     :clearable="true"
                     placeholder="请选择优惠券状态">
            <el-option v-for="item in statusList"
                       :key="item.fTypeID"
                       :label="item.Title"
                       :value="item.fTypeID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     size="small"
                     @click="couponBatchListQuery">查询</el-button>
          <el-button type="success"
                     size="small"
                     icon="el-icon-share"
                     :loading="export_loading"
                     v-if="is_export"
                     @click="exportData">{{export_msg}}</el-button>
        </el-form-item>
      </el-row>
    </el-form>

    <el-row>
      <el-col :span="24"
              style="height: 5px"></el-col>
    </el-row>
    <el-row>
      <el-table :data="couponBatchList"
                border
                highlight-current-row
                style="width: 100%"
                v-loading="loading"
                :height="tableHeight"
                ref="singleTable">
        <el-table-column type="index"
                         width="50"
                         label="序号"
                         :index="indexMethod">
        </el-table-column>
        <el-table-column prop="fCustNo"
                         width="75"
                         label="客户编号">
        </el-table-column>
        <el-table-column prop="fBatTtl"
                         width="120"
                         label="优惠券名称">
        </el-table-column>
        <el-table-column prop="fAppMerName"
                         width="120"
                         label="商户名称">
        </el-table-column>
        <el-table-column prop="fBatStartTime"
                         width="150"
                         label="起始时间">
        </el-table-column>
        <el-table-column prop="fBatEndTime"
                         width="150"
                         label="结束时间">
        </el-table-column>
        <el-table-column prop="fBatUseTimeName"
                         width="100"
                         label="使用时效">
        </el-table-column>
        <el-table-column prop="fCouponTypeName"
                         width="100"
                         label="抵扣说明">
        </el-table-column>
        <el-table-column prop="fStatusName"
                         width="100"
                         label="优惠券状态">
        </el-table-column>
        <el-table-column prop="fTotValue"
                         align="right"
                         width="100"
                         label="优惠券总量">
        </el-table-column>
        <el-table-column prop="fRemValue"
                         align="right"
                         width="100"
                         label="优惠券余量">
        </el-table-column>
        <el-table-column prop="fGetNum"
                         align="right"
                         width="75"
                         label="领用数量">
        </el-table-column>
        <el-table-column prop="fUseNum"
                         align="right"
                         width="75"
                         label="已用数量">
        </el-table-column>
        <el-table-column fixed="right"
                         align="center"
                         label="操作"
                         width="400">
          <template slot-scope="scope">
            <el-button @click="viewCouponBatch(scope.row)"
                       type="success"
                       size="mini">查看</el-button>
            <el-button size="mini"
                       type="warning"
                       @click="editCouponBatch(scope.$index, scope.row)"
                       v-if="is_edit&&parseFloat(scope.row.fTotValue)<=0">编辑</el-button>
            <el-button size="mini"
                       type="primary"
                       @click="rechargeCouponBatch(scope.$index, scope.row)"
                       v-if="is_recharge&&(scope.row.fStatus=='0'||scope.row.fStatus=='1')">充值</el-button>
            <el-button size="mini"
                       type="primary"
                       plain
                       @click="rechargeShow(scope.$index, scope.row)"
                       v-if="is_batch&&(scope.row.fStatus=='1'||scope.row.fStatus=='10')">充值列表</el-button>
            <el-button size="mini"
                       type="danger"
                       @click="deleteCouponBatch(scope.$index, scope.row)"
                       v-if="is_del&&parseFloat(scope.row.fTotValue)<=0">删除</el-button>
            <el-button size="mini"
                       type="info"
                       @click="invalid(scope.$index, scope.row)"
                       v-if="is_invalid&&scope.row.fStatus=='1'">作废</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row class="pagination">
      <el-col :span="24">
        <div class="block">
          <span class="demonstration"></span>
          <el-pagination background
                         @size-change="handleSizeChange"
                         :current-page.sync="pageIndex"
                         @current-change="handlePage"
                         :page-size="pageSize"
                         :page-sizes="[10, 20, 50, 100]"
                         layout="total,sizes, prev, pager, next, jumper"
                         :total="total"
                         v-if="total > 0">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <div class="couponBatchEditOrDetail">
      <el-dialog :title="detailTitle"
                 :visible.sync="couponBatchEditOrDetailVisible"
                 v-dialogDrag
                 top="7vh"
                 left="0vh"
                 width="50%">
        <el-form :model="curRowInfo"
                 :rules="rules"
                 ref="form"
                 label-width="140px">
          <el-row>
            <el-col :span="12">
              <el-form-item label="客户::"
                            prop="fCustID">
                <el-select v-model="curRowInfo.fCustID"
                           filterable
                           placeholder="请选择客户"
                           :disabled="!curRowInfo.isEdit"
                           @change="setPark($event, false)"
                           style="width: 100%">
                  <el-option v-for="item in choiceCusts"
                             :key="item.fCustID"
                             :label="item.unionName"
                             :value="item.fCustID">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12"
                    v-if="(curRowInfo.fBatchID||'').length>0">
              <el-form-item label="批次ID::">
                <el-input v-model="curRowInfo.fBatchID"
                          :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="申请商户::"
                            prop="fAppSelID">
                <el-select v-model="curRowInfo.fAppSelID"
                           filterable
                           placeholder="请选申请商户"
                           :disabled="!curRowInfo.isEdit"
                           style="width: 100%">
                  <el-option v-for="item in sellerList"
                             :key="item.fSelID"
                             :label="'【' + item.fSelName + '】' + item.fMerName"
                             :value="item.fSelID">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="优惠券分类::"
                            prop="fGroupID">
                <el-select v-model="curRowInfo.fGroupID"
                           filterable
                           placeholder="优惠券分类"
                           :disabled="!curRowInfo.isEdit"
                           style="width: 100%">
                  <el-option v-for="item in couponGroupList"
                             :key="item.fGroupID"
                             :label="item.fGroupName"
                             :value="item.fGroupID">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="适用停车场::"
                            prop="fParkID">
                <el-select v-model="curRowInfo.fParkID"
                           filterable
                           placeholder="请选择场库"
                           :disabled="!curRowInfo.isEdit"
                           style="width: 100%">
                  <el-option v-for="item in parks"
                             :key="item.fParkID"
                             :label="item.fParkName"
                             :value="item.fParkID">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <span style="color:red;margin-left:5px;line-height:32px;">有选择适用停车场时，要求该场库与其他场库不互通</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="优惠券名称::"
                            prop="fBatTtl">
                <el-input v-model="curRowInfo.fBatTtl"
                          placeholder="请输入优惠券名称"
                          autocomplete="off"
                          :disabled="!curRowInfo.isEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="起始时间::"
                            prop="fBatStartTime">
                <el-date-picker v-model="curRowInfo.fBatStartTime"
                                :disabled="!curRowInfo.isEdit"
                                style="width:200px"
                                type="datetime"
                                :clearable="false"
                                format="yyyy-MM-dd HH:mm"
                                placeholder="选择起始时间">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="结束时间::"
                            prop="fBatEndTime">
                <el-date-picker v-model="curRowInfo.fBatEndTime"
                                :disabled="!curRowInfo.isEdit"
                                style="width:200px"
                                type="datetime"
                                :clearable="false"
                                format="yyyy-MM-dd HH:mm"
                                placeholder="选择结束时间">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="使用时效(分钟)::"
                            prop="fBatUseTime"
                            class="time-form-item">
                <el-input v-model="curRowInfo.fBatUseTime"
                          placeholder="请输入使用时效（分钟）"
                          autocomplete="off"
                          :disabled="!curRowInfo.isEdit"></el-input>
                <!-- <span style="color:red;">优惠券领用后必须在指定使用时效内完成，值为0时不限制</span> -->
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <span style="color:red;margin-left:5px;line-height:32px;">优惠券领用后必须在指定使用时效内完成，值为0时不限制</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="优惠券抵扣方式::"
                            prop="fCouponType">
                <el-select v-model="curRowInfo.fCouponType"
                           filterable
                           placeholder="请选择优惠券抵扣方式"
                           :disabled="!curRowInfo.isEdit"
                           style="width: 100%">
                  <el-option v-for="item in choiceCouponTypeList"
                             :key="item.value"
                             :label="item.text"
                             :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="fCouponValueTitle"
                            prop="fCouponValue">
                <el-input v-model="curRowInfo.fCouponValue"
                          autocomplete="off"
                          :disabled="!curRowInfo.isEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="加减数值"
                            prop="fStepValue">
                <el-input v-model="curRowInfo.fStepValue"
                          autocomplete="off"
                          :disabled="!curRowInfo.isEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="备注"
                            prop="fRemark">
                <el-input type="textarea"
                          v-model="curRowInfo.fRemark"
                          :disabled="!curRowInfo.isEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer"
             class="dialog-footer">
          <el-button type="primary"
                     @click="submitForm('form')"
                     :loading="save_loading"
                     v-if="isShowSaveBtn">{{ save_msg }}</el-button>
          <el-button @click="couponBatchEditOrDetailVisible = false">取消</el-button>
        </div>
      </el-dialog>
      <el-dialog :title="dialogTitle"
                 :visible.sync="dialogVisible"
                 v-dialogDrag
                 top="7vh"
                 left="0vh"
                 width="50%">
        <el-form :model="form"
                 :rules="form_rules"
                 ref="recharge_form"
                 label-width="140px">
          <el-row>
            <el-col :span="12">
              <el-form-item label="客户::">
                <el-select v-model="form.fCustID"
                           :disabled="true"
                           style="width: 100%">
                  <el-option v-for="item in choiceCusts"
                             :key="item.fCustID"
                             :label="item.unionName"
                             :value="item.fCustID">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="批次ID::">
                <el-input v-model="form.fBatchID"
                          :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="商户名称::">
                <el-select v-model="form.fAppSelID"
                           :disabled="true"
                           style="width: 100%">
                  <el-option v-for="item in sellerList"
                             :key="item.fSelID"
                             :label="'【' + item.fSelName + '】' + item.fMerName"
                             :value="item.fSelID">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="优惠券名称::">
                <el-input v-model="form.fBatTtl"
                          :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="起始时间::">
                <el-input v-model="form.fBatStartTime"
                          :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="结束时间::">
                <el-input v-model="form.fBatEndTime"
                          :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="优惠券抵扣方式::">
                <el-select v-model="form.fCouponType"
                           :disabled="true"
                           style="width: 100%">
                  <el-option v-for="item in choiceCouponTypeList"
                             :key="item.value"
                             :label="item.text"
                             :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="form.fCouponValueTitle">
                <el-input v-model="form.fCouponValue"
                          autocomplete="off"
                          :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item :label="form.fTotValueTitle"
                            prop="fTotValue">
                <el-input v-model="form.fTotValue"
                          autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="备注"
                            prop="fRemark">
                <el-input type="textarea"
                          v-model="form.fRemark"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer"
             class="dialog-footer">
          <el-button type="primary"
                     @click="submitRechargeForm('recharge_form')"
                     :loading="save_loading">{{ save_msg }}</el-button>
          <el-button @click="dialogVisible = false">取消</el-button>
        </div>
      </el-dialog>
      <el-dialog :title="dialogTitle"
                 :visible.sync="dialogRechargeVisible"
                 v-dialogDrag
                 top="7vh"
                 left="0vh"
                 width="50%">
        <el-form :model="form"
                 label-width="140px">
          <el-row>
            <el-col :span="12">
              <el-form-item label="客户::">
                <el-select v-model="form.fCustID"
                           :disabled="true"
                           style="width: 100%">
                  <el-option v-for="item in choiceCusts"
                             :key="item.fCustID"
                             :label="item.unionName"
                             :value="item.fCustID">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="批次ID::">
                <el-input v-model="form.fBatchID"
                          :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="商户名称::">
                <el-select v-model="form.fAppSelID"
                           :disabled="true"
                           style="width: 100%">
                  <el-option v-for="item in sellerList"
                             :key="item.fSelID"
                             :label="'【' + item.fSelName + '】' + item.fMerName"
                             :value="item.fSelID">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="优惠券名称::">
                <el-input v-model="form.fBatTtl"
                          :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="起始时间::">
                <el-input v-model="form.fBatStartTime"
                          :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="结束时间::">
                <el-input v-model="form.fBatEndTime"
                          :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="优惠券抵扣方式::">
                <el-select v-model="form.fCouponType"
                           :disabled="true"
                           style="width: 100%">
                  <el-option v-for="item in choiceCouponTypeList"
                             :key="item.value"
                             :label="item.text"
                             :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="form.fCouponValueTitle">
                <el-input v-model="form.fCouponValue"
                          autocomplete="off"
                          :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-table :data="rechargeList"
                  border
                  highlight-current-row
                  style="width: 100%"
                  :height="300">
          <el-table-column prop="fOpLastTime"
                           label="操作时间">
          </el-table-column>
          <el-table-column prop="fOpUserNo"
                           label="操作员">
          </el-table-column>
          <el-table-column prop="fTotValue"
                           align="right"
                           label="充值数量">
          </el-table-column>
          <el-table-column prop="fRemark"
                           label="充值备注">
          </el-table-column>
        </el-table>
        <div slot="footer"
             class="dialog-footer">
          <el-button @click="dialogRechargeVisible = false">取消</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { coupon as api } from '../../api/coupon'
import * as user from '../../api/user'
import { mapActions } from 'vuex'
export default {
  name: 'rechargeCoupon',
  data () {
    var validateName = (rule, value, callback) => {
      if ((value || '').length > 0) {
        var patrn = /^[\u4e00-\u9fa5a-zA-Z0-9]+$/
        if (!patrn.test(value)) {
          callback(new Error('不能包含特殊字符'))
        }
      }
      callback()
    }
    var validateTotValue = (rule, value, callback) => {
      if ((value || '').length > 0) {
        var patrn = /^\+?[0-9][0-9]*$/
        if (!patrn.test(value)) {
          callback(new Error('请输入有效大于0的整数'))
        }
      } else {
        callback(new Error('请输入' + this.form.fTotValueTitle))
      }
      callback()
    }
    return {
      selGroupID: '',
      choiceGroups: [],
      export_loading: false,
      save_loading: false,
      dialogRechargeVisible: false,
      isShowSaveBtn: false,
      loading: false,
      dialogTitle: '',
      dialogVisible: false,
      save_msg: '保存',
      export_msg: '导出',
      rechargeList: [],
      couponGroupList: [{ fGroupID: '0', fGroupName: '无' }],
      selCouponGroupList: [],
      fGroupID: '',
      curRowInfo: {
        op: '',
        isEdit: false,
        fCustID: '',
        fBatchID: '',
        fAppSelID: '',
        fParkID: '0',
        fBatTtl: '',
        fRemark: '',
        fBatStartTime: '',
        fBatEndTime: '',
        fBatUseTime: '',
        fCouponType: '',
        fCouponValue: '',
        fGroupID: '0',
        fStepValue: ''
      },
      form: {
        fBigRowID: '',
        fBatchID: '',
        fCustID: '',
        fAppSelID: '',
        fBatTtl: '',
        fBatStartTime: '',
        fBatEndTime: '',
        fCouponType: '',
        fCouponValue: '',
        fCouponValueTitle: '',
        fTotValueTitle: '',
        fTotValue: '',
        fRemark: ''

      },
      couponBatchEditOrDetailVisible: false,
      detailTitle: '',
      syncouponBatchList: [],
      couponBatchList: [],
      is_edit: false,
      is_del: false,
      is_export: false,
      is_recharge: false,
      is_invalid: false,
      is_batch: false,
      fStatus: '',
      selCustID: '',
      selBatTtl: '',
      choiceCusts: [],
      selSellID: '',
      choiceSellers: [],
      sellerList: [],
      choiceCouponTypeList: [{ value: '1', text: '金额抵扣（元）' }, { value: '2', text: '时间抵扣（小时）' }],
      default_couponType: '1',
      parks: [],
      statusList: [
        { fTypeID: '0', Title: '待审核' },
        { fTypeID: '1', Title: '已审核' },
        { fTypeID: '10', Title: '已作废' }
      ],
      couponBatchActiveName: 'couponBatchList',
      tableHeight: 0,
      rules: {
        fCustID: [{ required: true, message: '请选择客户', trigger: 'change' }],
        fAppSelID: [{ required: true, message: '请选择商户', trigger: 'change' }],
        fParkID: [{ required: true, message: '请选择场库', trigger: 'change' }],
        fBatStartTime: [{ required: true, message: '请选择开始时间', trigger: 'change' }],
        fBatEndTime: [{ required: true, message: '请选择结束时间', trigger: 'change' }],
        fBatUseTime: [{ required: true, message: '请填写使用失效', trigger: 'blur' }],
        fCouponType: [{ required: true, message: '请选择抵扣方式', trigger: 'change' }],
        fCouponValue: [{ required: true, message: '请填写抵扣值', trigger: 'blur' }],
        fStepValue: [{ required: true, message: '请填写抵扣步长值', trigger: 'blur' }],
        fBatTtl: [
          { required: true, message: '请输入优惠券名称', trigger: 'blur' },
          { validator: validateName, trigger: 'blur' },
          { min: 1, max: 99, message: '长度在 1 到 99 个字符', trigger: 'blur' }
        ]
      },
      form_rules: {
        fTotValue: [{ required: true, validator: validateTotValue, trigger: 'blur' }]
      },
      pageSize: 20,
      pageIndex: 1,
      total: 0,
      couponValueEnable: false
    }
  },
  computed: {
    fCouponValueTitle: function () {
      let value = this.curRowInfo.fCouponType
      let text = ''
      for (var i = 0; i < this.choiceCouponTypeList.length; i++) {
        if (this.choiceCouponTypeList[i].value === value) {
          text = this.choiceCouponTypeList[i].text
          break
        }
      }
      return text + '::'
    }
  },
  methods: {
    ...mapActions(['getCustByGroup', 'getParkList']),
    invalid (index, row) {
      this.$confirm(
        '是否将该优惠券批次【' +
        row.fBatTtl +
        '】作废, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          api
            .nullifyRechargeCoupon({
              fBigRowID: row.fBigRowID
            })
            .then(res => {
              if (res && res.data) {
                var data = res.data
                if (data.IsOk) {
                  this.$message.success('提示：' + data.Msg)
                  this.initData()
                } else {
                  this.$message.error('提示：' + data.Msg)
                }
              }
            })
        })
        .catch(() => { })
    },
    rechargeCouponBatch (index, row) {
      this.dialogTitle = '【' + row.fBatTtl + '】充值优惠券'
      for (let key in this.form) {
        this.form[key] = ''
      }
      this.form.fBigRowID = row.fBigRowID
      this.form.fBatchID = row.fBatchID
      this.form.fCustID = row.fCustID
      this.form.fAppSelID = row.fAppSelID
      this.form.fBatTtl = row.fBatTtl
      this.form.fBatStartTime = row.fBatStartTime
      this.form.fBatEndTime = row.fBatEndTime
      this.form.fCouponType = row.fCouponType
      this.form.fCouponValue = row.fCouponValue
      if (row.fCouponType === '1') {
        this.form.fCouponValueTitle = '金额抵扣（元）::'
        this.form.fTotValueTitle = '充值金额（元）'
      } else {
        this.form.fCouponValueTitle = '时间抵扣（小时）::'
        this.form.fTotValueTitle = '充值时间（小时）'
      }
      this.dialogVisible = true
      setTimeout(() => {
        if (this.$refs['recharge_form']) {
          this.$refs['recharge_form'].clearValidate()
        }
      }, 50)
    },
    rechargeShow (index, row) {
      this.dialogTitle = '【' + row.fBatTtl + '】充值优惠券'
      for (let key in this.form) {
        this.form[key] = ''
      }
      this.form.fBigRowID = row.fBigRowID
      this.form.fBatchID = row.fBatchID
      this.form.fCustID = row.fCustID
      this.form.fAppSelID = row.fAppSelID
      this.form.fBatTtl = row.fBatTtl
      this.form.fBatStartTime = row.fBatStartTime
      this.form.fBatEndTime = row.fBatEndTime
      this.form.fCouponType = row.fCouponType
      this.form.fCouponValue = row.fCouponValue
      if (row.fCouponType === '1') {
        this.form.fCouponValueTitle = '金额抵扣（元）::'
      } else {
        this.form.fCouponValueTitle = '时间抵扣（小时）::'
      }
      this.rechargeList = []
      api.rechargeList({ fCustID: row.fCustID, fBatchID: row.fBatchID }).then(res => {
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              this.rechargeList = data.Data || []
            }
          }
        }
      })
      this.dialogRechargeVisible = true
    },
    submitRechargeForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.save_loading = true
          this.save_msg = '保存中…'
          api.rechargeCoupon(this.form).then(res => {
            this.save_loading = false
            this.save_msg = '保存'
            let { status, data } = res
            if (status !== 200) {
              this.$message.error('提示：优惠券操作出错')
            } else {
              if (!data.IsOk) {
                this.$message.error(data.Msg)
              } else {
                this.initData()
                this.$message.success(data.Msg)
                this.dialogVisible = false
              }
            }
          })
        } else {
          console.log('rechargeCoupon error submit!!')
          return false
        }
      })
    },
    changeGroup (val) {
      this.choiceSellers = []
      this.selSellID = ''
      if (val || this.selCustID) {
        this.setSellDDL(this.selCustID, val).then(res => {
          if (res && res.data) {
            let { status, data } = res
            if (status === 200) {
              if (data.IsOk) {
                this.choiceSellers = data.Data || []
              }
            }
          }
        })
      }
    },
    setPark (val, isEdit) {
      this.parks = []
      this.getParkList({ fCustID: val }).then(res => {
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              // Object.assign(this.parks, data.Data || [])
              this.parks = data.Data || []
            }
          }
          let all = {}
          all['fParkID'] = '0'
          all['fParkName'] = '所有停车场'
          this.parks.unshift(all)
          if (!isEdit) {
            this.curRowInfo.fParkID = '0'
          }
        }
      })
      this.couponGroupList = [{ fGroupID: '0', fGroupName: '无' }]
      this.curRowInfo.fGroupID = '0'
      api.getCouponGroupList({ fCustID: val }).then(res => {
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              this.couponGroupList.push(...(data.Data || []))
            }
          }
        }
      })
      this.sellerList = []
      this.curRowInfo.fAppSelID = ''
      this.setSellDDL(val).then(res => {
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              this.sellerList = data.Data || []
              if (this.sellerList && this.sellerList.length > 0 && !isEdit) {
                this.curRowInfo.fAppSelID = this.sellerList[0].fSelID
              }
            }
          }
        }
      })
    },
    setQuerySeller (val) {
      this.choiceSellers = []
      this.selSellID = ''
      this.selCouponGroupList = []
      this.fGroupID = ''
      this.choiceGroups = []
      this.selGroupID = ''
      if (!val) { return }
      this.setSellDDL(val, this.selGroupID).then(res => {
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              this.choiceSellers = data.Data || []
            }
          }
        }
      })
      api.getCouponGroupList({ fCustID: val }).then(res => {
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              this.selCouponGroupList = data.Data || []
            }
          }
        }
      })

      api.getSellerGroupList({ fCustID: val }).then(res => {
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              this.choiceGroups = data.Data || []
            }
          }
        }
      })
    },
    setSellDDL (fCustID, fSelGrpID) {
      return api.getSellerListByCustIDAsync({ fCustID: fCustID, fSelGrpID: fSelGrpID })
    },
    setDefault () {
      this.sellerList = []
      for (let key in this.curRowInfo) {
        this.curRowInfo[key] = ''
      }
      this.curRowInfo.fGroupID = '0'
      var today = new Date()
      this.curRowInfo.fBatStartTime = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate(),
        0,
        0,
        0
      )
      this.curRowInfo.fBatEndTime = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate(),
        23,
        59,
        59
      )
      this.curRowInfo['fParkID'] = '0'
      this.curRowInfo.fCouponType = this.default_couponType
    },
    submitForm (formName) {
      let timeFormat = 'yyyy-MM-dd hh:mm:ss'
      var dateStart = new Date(this.curRowInfo.fBatStartTime)
      var dateEnd = new Date(this.curRowInfo.fBatEndTime)
      if (dateStart >= dateEnd) {
        this.$message.error('提示：优惠券【起始时间】要小于【结束时间】')
        return
      }
      dateStart.setFullYear(dateStart.getFullYear() + 1)

      if (dateEnd > dateStart) {
        this.$message.error('提示：优惠券有效期要小于一年')
        return
      }
      if (this.curRowInfo.fBatStartTime instanceof Date) {
        this.curRowInfo.fBatStartTime = this.$dateFormat(
          this.curRowInfo.fBatStartTime,
          timeFormat
        )
      }
      if (this.curRowInfo.fBatEndTime instanceof Date) {
        this.curRowInfo.fBatEndTime = this.$dateFormat(
          this.curRowInfo.fBatEndTime,
          timeFormat
        )
      }

      this.$refs[formName].validate(valid => {
        if (valid) {
          this.save_loading = true
          this.save_msg = '保存中…'
          api.saveRechargeCoupon(this.curRowInfo).then(res => {
            this.save_loading = false
            this.save_msg = '保存'
            let { status, data } = res
            if (status !== 200) {
              this.$message.error('提示：优惠券操作出错')
            } else {
              if (!data.IsOk) {
                this.$message.error(data.Msg)
              } else {
                this.initData()
                this.$message.success(data.Msg)
                this.couponBatchEditOrDetailVisible = false
              }
            }
          })
        } else {
          console.log('rechargeCoupon error submit!!')
          return false
        }
      })
    },
    addCouponBatch () {
      this.setDefault()
      this.isShowSaveBtn = true
      this.couponBatchEditOrDetailVisible = true
      this.curRowInfo.op = 'add'
      this.curRowInfo.isEdit = true
      this.detailTitle = '新增优惠券'
      setTimeout(() => {
        if (this.$refs['form']) {
          this.$refs['form'].clearValidate()
        }
      }, 50)
    },
    editCouponBatch (index, row) {
      if (this.$refs['form']) {
        this.$refs['form'].clearValidate()
      }
      if (row && row !== null && typeof row !== 'undefined') {
        this.setPark(row.fCustID, true)
        let curRow = {}
        Object.assign(curRow, row)
        this.curRowInfo = curRow
        this.detailTitle = '【' + row.fBatTtl + '】编辑优惠券'
        this.curRowInfo.isEdit = true
        this.curRowInfo.op = 'edit'
        this.couponBatchEditOrDetailVisible = true
        this.isShowSaveBtn = true
        if (parseInt(row.fCreNums) > 0) {
          this.curRowInfo.isEdit = false
        }
      }
    },
    viewCouponBatch (row) {
      this.curRowInfo.isEdit = false
      this.isShowSaveBtn = false
      if (row && row !== null && typeof row !== 'undefined') {
        this.setPark(row.fCustID, true)
        Object.assign(this.curRowInfo, row)
        this.detailTitle = '【' + row.fBatTtl + '】查看优惠券'
        this.couponBatchEditOrDetailVisible = true
      }
    },
    deleteCouponBatch (index, row) {
      this.$confirm('删除【' + row.fBatTtl + '】该优惠券记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          api.deleteRechargeCoupon({ fBigRowID: row.fBigRowID }).then(res => {
            let { status, data } = res
            if (status === 200) {
              if (data.IsOk) {
                this.$message({
                  type: 'success',
                  message: data.Msg
                })
                this.initData()
              } else {
                this.$message.error('提示：' + data.Msg)
              }
            }
          })
        })
        .catch(_ => {
          console.log(_)
        })
    },
    couponBatchListQuery () {
      this.initData()
    },
    handleSizeChange (value) {
      this.pageSize = value
      this.initData()
    },
    handlePage (index) {
      this.pageIndex = index
      this.initData()
    },
    indexMethod (index) {
      return this.pageSize * (this.pageIndex - 1) + index + 1
    },
    initData () {
      this.total = 0
      this.couponBatchList = []
      this.loading = true
      api.getRechargeCouponList({
        fGroupID: this.fGroupID,
        fCustID: this.selCustID,
        fStatus: this.fStatus,
        fSelGrpID: this.selGroupID,
        fAppSelID: this.selSellID,
        fBatTtl: this.selBatTtl,
        pageSize: this.pageSize,
        pageIndex: this.pageIndex
      })
        .then(res => {
          this.loading = false
          if (res && res.data) {
            let { status, data } = res
            if (status === 200) {
              if (data.IsOk) {
                this.couponBatchList = data.Data.rows
                this.total = data.Data.total
              } else {
                this.$message.error('提示:' + data.Msg)
              }
            } else {
              this.$message.error('提示:' + data.Msg)
            }
          }
        })
    },
    exportData () {
      if ((this.selCustID || '').trim().length <= 0) {
        this.$message.error('提示：请先选择客户')
        return false
      }
      this.export_loading = true
      this.export_msg = '导出中……'
      var custArr = (this.choiceCusts || []).filter((item) => {
        return item.fCustID === this.selCustID
      })
      var fileName = custArr.length > 0 ? custArr[0].unionName : ''
      api.getRechargeCouponList({
        isExport: 1,
        fGroupID: this.fGroupID,
        fCustID: this.selCustID,
        fStatus: this.fStatus,
        fSelGrpID: this.selGroupID,
        fAppSelID: this.selSellID,
        fBatTtl: this.selBatTtl
      }).then(res => {
        this.export_loading = false
        this.export_msg = '导出'
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            if (data.Data) {
              this.fileDownload(data.Data, fileName + '_充值优惠券.xls')
            }
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
    },
    tableRowClassName ({ row, rowIndex }) {
      if (row.fIsDel === '1') {
        return 'warning-row'
      }
      return ''
    },
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 246
      obj.tableHeight = clientHeight
    }
  },
  created () {
    user.getCurrentUserPers({ perTypeId: 1019000 }).then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          if (data.Data) {
            this.is_edit = data.Data.data.is_edit
            this.is_del = data.Data.data.is_del
            this.is_recharge = data.Data.data.is_recharge
            this.is_invalid = data.Data.data.is_invalid
            this.is_export = data.Data.data.is_export
            this.is_batch = data.Data.data.is_batch
          }
        } else {
          this.$message.error('提示：加载当前用户权限信息失败')
        }
      }
    })
    // this.initData()
  },
  mounted () {
    let sizethis = this
    window.onresize = () => {
      this.setTableHeight(sizethis)
    }

    this.getCustByGroup().then(res => {
      if (res && res.data) {
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            this.choiceCusts = data.Data
            if (this.choiceCusts && this.choiceCusts.length === 1) {
              this.selCustID = this.choiceCusts[0].fCustID
              this.setQuerySeller(this.selCustID)
            }
          }
        }
      }
    })
  },
  updated () {
    this.setTableHeight(this)
  }
}
</script>

<style>
#rechargeCoupon .el-checkbox__input.is-disabled + span.el-checkbox__label {
  color: #606266;
}
#rechargeCoupon
  .el-checkbox__input.is-disabled.is-checked
  .el-checkbox__inner::after {
  border-color: #000000;
}
#rechargeCoupon .is-disabled .el-input__inner,
#rechargeCoupon .is-disabled .el-textarea__inner {
  color: #606266;
}
#rechargeCoupon .warning-row {
  color: chocolate;
}
#rechargeCoupon .time-form-item .el-form-item__content {
  line-height: normal;
}
#rechargeCoupon .couponBatchEditOrDetail .el-dialog__title {
  color: white;
}
#rechargeCoupon .couponBatchEditOrDetail .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
#rechargeCoupon .couponBatchEditOrDetail .el-dialog__body {
  padding-bottom: 5px;
}
#rechargeCoupon .couponBatchEditOrDetail .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}
#rechargeCoupon .el-dialog__body {
  padding: 10px 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}
</style>
<style scoped>
.pagination {
  text-align: right;
  padding-top: 5px;
}
.pageSearch .el-form-item {
  margin-bottom: 5px;
}
@page {
  margin: 5px;
}
</style>



// WEBPACK FOOTER //
// src/view/coupon/rechargeCoupon.vue